import { DashboardRoutes } from "@/router";
import { useNavigate } from "react-router-dom";
import { isMobileBusinessRegisterURL } from "@/utils/isRegisterURL";

export function useHandleNavigationURL() {
  const isRegisterURL = isMobileBusinessRegisterURL();
  const { settings, register } = DashboardRoutes;
  const navigate = useNavigate();

  const handleNavigationURL = () => {
    if (isRegisterURL) return navigate(register.business.url);
    return navigate(settings.personal.root.url);
  };

  return { handleNavigationURL };
}
